import React from "react";
import $ from "jquery";
import { notify } from "react-notify-toast";
import Page from "./../../Page";
import { API_GENDER, API_PROGRAM, API_INSTITUTE } from "../../Util";
import { Button, Modal } from "react-materialize";
import RegisterPasswordSmile from "./RegisterPasswordSmile";
import { trans } from "./../../Lang";

class Register extends Page {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        fullname: "",
        phoneNumber: "",
        email: "",
        password: "",
        confirmPassword: "",
        program_id: "",
        birth_date: "",
        institute_id: 0,
        other_institute: "",
        asn_employee: "",
        employee_no: "",
      },
      formErrors: {
        errorFullname: "",
        errorPhoneNumber: "",
        errorEmail: "",
        errorPassword: "",
        errorConfirmPassword: "",
        errorProgram: "",
        errorBirthDate: "",
        errorInstituteId: "",
        errorOtherInstitute: "",
        errorAsnEmployee: "",
        errorEmployeeNo: "",
      },
      isPasswordHidden: true,
      isConfirmPasswordHidden: true,
      optionGenders: [],
      optionPrograms: [],
      optionInstitutes: [],
      setData: false,
    };

    // special char untuk gelar
    this.regexFullname = RegExp(/^[A-Za-z.,/ ]+$/);
    this.regexEmail = RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/);
    this.regexSpecialCharacter = RegExp(
      /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/
    );
    this.regexPassword = RegExp(/^(?=.*\d)(?=.*[a-zA-Z]).*$/);
    this.clientToken = "aa6d8694eea3d1b52aa6e4169b0a822665b56fc4";
  }

  componentDidMount() {
    this.getGender();
    this.getPrograms();
    this.getInstitutes();
  }

  componentDidUpdate() {
    const { data } = this.props;
    const { setData } = this.state;

    if (data && data["email"] && !setData) {
      let formData = {
        fullname: data["name"] || null,
        phoneNumber: data["phone"] || null,
        email: data["email"] || null,
        username_smile: data["smile_username"] || null,
        password: "",
        confirmPassword: "",
        gender: data["gender"] || null,
        program_id: data["program_id"] || null,
        birth_date: data["birth_date"] || null,
        institute_id: data["institute_id"]
          ? data["institute_id"]
          : data["other_institute"]
          ? "other"
          : null,
        other_institute: data["other_institute"] || null,
        asn_employee: data["asn_employee"] ? "true" : "false",
        employee_no: data["employee_no"] || null,
      };

      this.setState({ setData: true, formData });
    }
  }

  handleChange = (e) => {
    let { value, name } = e.target;
    let { formData } = this.state;

    switch (name) {
      case "fullname":
        formData.fullname = value;
        break;
      case "username_smile":
        formData.username_smile = value;
        break;
      case "phoneNumber":
        formData.phoneNumber = value;
        break;
      case "email":
        formData.email = value;
        break;
      case "password":
        formData.password = value;
        break;
      case "password_smile":
        formData.password_smile = value;
        break;
      case "program_id":
        formData.program_id = value;
        break;
      case "confirmPassword":
        formData.confirmPassword = value;
        break;
      case "gender":
        formData.gender = value;
        break;
      case "birth_date":
        formData.birth_date = value;
        break;
      case "asn_employee":
        formData.asn_employee = value;
        break;
      case "employee_no":
        formData.employee_no = value;
        break;
      case "institute_id":
        formData.institute_id = value;
        break;
      case "other_institute":
        formData.other_institute = value;
        break;
      default:
        break;
    }

    this.setState({ formData });
  };

  handleSubmit = async (e, forceSubmit = false) => {
    e.preventDefault();
    if (this.checkIsFormValid()) {
      const { type } = this.props;
      let {
        fullname,
        phoneNumber,
        email,
        password,
        gender,
        username_smile,
        password_smile,
        program_id,
        birth_date,
        asn_employee,
        employee_no,
        institute_id,
        other_institute,
      } = this.state.formData;
      let params, dataRegister;

      params = {
        phone: phoneNumber,
        "g-recaptcha-response": "zzz",
      };

      dataRegister = {
        name: fullname,
        phone: phoneNumber,
        username_smile,
        password_smile,
        password,
        email,
        gender,
        register_type: type,
        program_id,
        birth_date,
        asn_employee,
        employee_no,
        institute_id,
        other_institute,
      };

      if (type == "smile") {
        delete dataRegister["institute_id"];
        delete dataRegister["other_institute"];
      } else {
        if (dataRegister["institute_id"] != "other") {
          dataRegister["other_institute"] = "";
        } else {
          dataRegister["institte_id"] = "";
        }
        if (dataRegister["asn_employee"] == "false") {
          dataRegister["employee_no"] = "";
        }
      }

      //   if (type == "smile" && !forceSubmit) {
      //     $("#trigger-modal-password").trigger("click");
      //     return false;
      //   } else {
      this.props.onSubmit(e, dataRegister, forceSubmit);
      //   }
    }
  };

  getGender() {
    $.get(API_GENDER).then((data) => {
      if (data.payload) {
        this.setState({ optionGenders: data.payload });
      } else {
        notify.show("Terdapat kesalahan, silakan coba lagi", "warning");
      }
    });
  }

  getPrograms = () => {
    $.get(API_PROGRAM).then((data) => {
      if (data.payload) {
        let options = [...data.payload];
        options = options.filter((row) => {
          return row.has_url;
        });
        options =
          options.map((obj) => ({
            label: obj.name,
            value: obj.id,
          })) || [];

        this.setState({ optionPrograms: options });
      }
    });
  };

  getInstitutes = () => {
    $.get(API_INSTITUTE).then((data) => {
      if (data.payload) {
        let options =
          data.payload.map((obj) => ({
            label: obj.name,
            value: obj.id,
          })) || [];

        this.setState({ optionInstitutes: options });
      }
    });
  };

  checkIsFormValid = () => {
    let {
      fullname,
      phoneNumber,
      email,
      password,
      confirmPassword,
      gender,
      username_smile,
      program_id,
      birth_date,
      asn_employee,
      employee_no,
      institute_id,
      other_institute,
    } = this.state.formData;
    let { formErrors } = this.state;
    let { type, formType } = this.props;
    let isValid = true;

    // Fullname Validation
    if (!fullname) {
      formErrors.errorFullname = "Nama harus diisi";
    } else if (!this.regexFullname.test(fullname)) {
      formErrors.errorFullname = "Hanya dapat memasukkan huruf";
    } else {
      formErrors.errorFullname = "";
    }

    if (!gender) {
      formErrors.errorGender = "Gender harus diisi";
    } else {
      formErrors.errorGender = "";
    }

    if (!asn_employee) {
      formErrors.errorAsnEmployee = "Field ini harus diisi";
    } else {
      formErrors.errorAsnEmployee = "";
    }

    if (asn_employee == "true" && !employee_no) {
      formErrors.errorEmployeeNo = "Field ini harus diisi";
    } else {
      formErrors.errorEmployeeNo = "";
    }

    if (!birth_date) {
      formErrors.errorBirthDate = "Tanggal Lahir harus diisi";
    } else {
      formErrors.errorBirthDate = "";
    }

    if (!institute_id && type != "smile") {
      formErrors.errorInstituteId = "Instansi harus diisi";
    } else {
      formErrors.errorInstituteId = "";
    }

    if (institute_id == "other" && type != "smile" && !other_institute) {
      formErrors.errorOtherInstitute = "Instansi lainnya harus diisi";
    } else {
      formErrors.errorOtherInstitute = "";
    }

    if (!username_smile && type == "smile" && !formType) {
      formErrors.errorUsernameSmile = "Username harus diisi";
    } else {
      formErrors.errorUsernameSmile = "";
    }

    if (!program_id && type == "smile") {
      formErrors.errorProgram = "Program harus diisi";
    } else {
      formErrors.errorProgram = "";
    }

    if (phoneNumber && (phoneNumber.length < 10 || isNaN(phoneNumber))) {
      formErrors.errorPhoneNumber =
        "Nomor handphone yang anda masukkan tidak valid";
    } else {
      formErrors.errorPhoneNumber = "";
    }

    if (!email) {
      formErrors.errorEmail = "Email harus diisi";
    } else if (!this.regexEmail.test(email)) {
      formErrors.errorEmail = "Email yang anda masukkan tidak valid";
    } else {
      formErrors.errorEmail = "";
    }

    // Password Validation
    if (!password && !formType) {
      formErrors.errorPassword = "Password harus diisi";
    } else if (password.length < 6 && !formType) {
      formErrors.errorPassword = "Minimal password 6 karakter";
    } else if (!this.regexPassword.test(password) && !formType) {
      formErrors.errorPassword = "Password harus mengandung huruf dan angka";
    } else if (!formType) {
      formErrors.errorPassword = "";
      formErrors.errorConfirmPassword =
        password !== confirmPassword
          ? "Password yang anda masukkan tidak sesuai"
          : "";
    }

    this.setState({ formErrors });

    // RETURN ISVALID
    Object.values(formErrors).forEach((value) => {
      if (value) {
        this.setState;
        isValid = false;
      }
    });

    return isValid;
  };

  handleResetError = () => {};

  handleToggleShowPassword = (e) => {
    let { id } = e.target;
    if (id === "password")
      this.setState({ isPasswordHidden: !this.state.isPasswordHidden });
    if (id === "confirmPassword")
      this.setState({
        isConfirmPasswordHidden: !this.state.isConfirmPasswordHidden,
      });
  };

  render() {
    let {
      fullname,
      phoneNumber,
      email,
      username_smile,
      gender,
      birth_date,
      asn_employee,
      employee_no,
      institute_id,
      other_institute,
      program_id,
    } = this.state.formData;
    let {
      errorEmail,
      errorProgram,
      errorPassword,
      errorFullname,
      errorPhoneNumber,
      errorConfirmPassword,
      errorGender,
      errorUsernameSmile,
      errorBirthDate,
      errorInstituteId,
      errorOtherInstitute,
      errorAsnEmployee,
      errorEmployeeNo,
    } = this.state.formErrors;
    let {
      isPasswordHidden,
      isConfirmPasswordHidden,
      optionGenders,
      optionPrograms,
      optionInstitutes,
    } = this.state;

    const { type, formType } = this.props;

    return (
      <div>
        <form id="form-register" onSubmit={this.handleSubmit}>
          {type == "smile" ? (
            <div className="input-field">
              <input
                name="username_smile"
                type="text"
                disabled={formType == "profile"}
                placeholder="Username SMILE"
                onChange={this.handleChange}
                value={username_smile}
                autoComplete="one-time-code"
              />
              {errorUsernameSmile ? (
                <div className="red-text text-darken-2 font-tiny">
                  {errorUsernameSmile}
                </div>
              ) : null}
              <div className="font-tiny">
                Masukkan username SMILE Anda, misal d5x_far untuk provinsi,
                d51xx_hiv untuk kabupaten/kota, p10500xx_tb untuk puskesmas
              </div>
            </div>
          ) : null}

          <div className="input-field">
            <input
              name="email"
              type="email"
              disabled={formType == "profile"}
              placeholder="Email"
              onChange={this.handleChange}
              value={email}
            />
            {errorEmail ? (
              <div className="red-text text-darken-2 font-tiny">
                {errorEmail}
              </div>
            ) : null}
            <div className="font-tiny">
              Masukkan email Anda, misal ade.putra@mail.com
            </div>
          </div>

          {formType != "profile" ? (
            <div className="input-field">
              <input
                name="password"
                placeholder="Buat Password"
                type={isPasswordHidden ? "password" : "text"}
                onChange={this.handleChange}
              />
              <i
                id="password"
                className="btn-show-hide-password material-icons"
                onClick={this.handleToggleShowPassword}
              >
                {isPasswordHidden ? "visibility_off" : "visibility"}
              </i>
              {errorPassword ? (
                <div className="red-text text-darken-2 font-tiny">
                  {errorPassword}
                </div>
              ) : null}
              <div className="font-tiny">
                Masukkan password untuk akun eLearning Anda
              </div>
            </div>
          ) : null}

          {formType != "profile" ? (
            <div className="input-field">
              <input
                name="confirmPassword"
                placeholder="Konfirmasi Password"
                type={isConfirmPasswordHidden ? "password" : "text"}
                onChange={this.handleChange}
              />
              <i
                id="confirmPassword"
                className="btn-show-hide-password material-icons"
                onClick={this.handleToggleShowPassword}
              >
                {isConfirmPasswordHidden ? "visibility_off" : "visibility"}
              </i>
              {errorConfirmPassword ? (
                <div className="red-text text-darken-2 font-tiny">
                  {errorConfirmPassword}
                </div>
              ) : null}
            </div>
          ) : null}

          <div className="input-field">
            <input
              name="fullname"
              type="text"
              placeholder="Nama Lengkap"
              onChange={this.handleChange}
              value={fullname}
            />
            {errorFullname ? (
              <div className="red-text text-darken-2 font-tiny">
                {errorFullname}
              </div>
            ) : null}
          </div>

          <div className="input-field">
            <input
              name="birth_date"
              type="date"
              className="datepicker"
              placeholder="Tanggal lahir"
              onChange={this.handleChange}
              value={birth_date}
            />
            {errorBirthDate ? (
              <div className="red-text text-darken-2 font-tiny">
                {errorBirthDate}
              </div>
            ) : null}
            <span className="font-tiny">Masukkan Tanggal lahir Anda</span>
          </div>

          <div>
            <select
              name="gender"
              onChange={this.handleChange}
              className="browser-default"
              value={gender}
            >
              <option value="">Pilih Jenis Kelamin</option>
              {optionGenders.map((opt) => (
                <option value={opt.value}>
                  {trans[opt.label.toLowerCase()]}
                </option>
              ))}
            </select>
            {errorGender ? (
              <div className="red-text text-darken-2 font-tiny">
                {errorGender}
              </div>
            ) : null}
          </div>

          <div className="input-field row">
            <input
              name="phoneNumber"
              type="tel"
              placeholder="Nomor Handphone (optional)"
              className="col s12"
              onChange={this.handleChange}
              value={phoneNumber}
            />
            {errorPhoneNumber ? (
              <div className="red-text text-darken-2 font-tiny">
                {errorPhoneNumber}
              </div>
            ) : null}
          </div>

          {type != "smile" ? (
            <div style={{ margin: "16px auto" }}>
              <div>
                <select
                  name="institute_id"
                  onChange={this.handleChange}
                  className="browser-default"
                  value={institute_id}
                >
                  <option value="">Pilih Instansi</option>
                  {optionInstitutes.map((opt) => (
                    <option value={opt.value}>{opt.label}</option>
                  ))}
                </select>
                {errorInstituteId ? (
                  <div className="red-text text-darken-2 font-tiny">
                    {errorInstituteId}
                  </div>
                ) : null}
              </div>

              {institute_id == "other" ? (
                <div className="input-field row">
                  <input
                    name="other_institute"
                    type="text"
                    placeholder="Instansi Lain"
                    className="col s12"
                    onChange={this.handleChange}
                    value={other_institute}
                  />
                  {errorOtherInstitute ? (
                    <div className="red-text text-darken-2 font-tiny">
                      {errorOtherInstitute}
                    </div>
                  ) : null}
                </div>
              ) : null}
            </div>
          ) : null}

          <div style={{ margin: "16px auto" }}>
            <div>Apakah anda seorang Pegawai Negeri Sipil</div>
            <div
              className="row"
              style={{ marginTop: "4px", marginBottom: "4px" }}
            >
              <div className="col s3">
                <input
                  name="asn_employee"
                  type="radio"
                  id="asn_employee_1"
                  value="true"
                  onChange={this.handleChange}
                  checked={asn_employee == "true"}
                />
                <label htmlFor="asn_employee_1">Ya</label>
              </div>

              <div className="col s3">
                <input
                  name="asn_employee"
                  type="radio"
                  id="asn_employee_2"
                  value="false"
                  onChange={this.handleChange}
                  checked={asn_employee == "false"}
                />
                <label htmlFor="asn_employee_2">Tidak</label>
              </div>
            </div>
            {errorAsnEmployee ? (
              <div className="red-text text-darken-2 font-tiny">
                {errorAsnEmployee}
              </div>
            ) : null}
          </div>

          {asn_employee == "true" ? (
            <div className="input-field row">
              <input
                name="employee_no"
                type="text"
                placeholder="Nomor Induk Pegawai"
                className="col s12"
                onChange={this.handleChange}
                value={employee_no}
              />
              {errorEmployeeNo ? (
                <div className="red-text text-darken-2 font-tiny">
                  {errorEmployeeNo}
                </div>
              ) : null}
            </div>
          ) : null}

          {type == "smile" ? (
            <div style={{ marginTop: "16px" }}>
              <select
                name="program_id"
                onChange={this.handleChange}
                className="browser-default"
                value={program_id}
                disabled={formType == "profile"}
              >
                <option value="">Pilih Program</option>
                {optionPrograms.map((opt) => (
                  <option value={opt.value}>{opt.label}</option>
                ))}
              </select>
              {errorProgram ? (
                <div className="red-text text-darken-2 font-tiny">
                  {errorProgram}
                </div>
              ) : null}
            </div>
          ) : null}

          {this.props.submitButton ? (
            this.props.submitButton
          ) : (
            <div className="form-auth__button-group mt-s">
              <button className="btn full mb-s modal-trigger">Daftar</button>
            </div>
          )}
        </form>
      </div>
    );
  }
}

export default Register;



// WEBPACK FOOTER //
// ./src/components/Auth/components/Register.js